import debug from 'bows';
import Flickity from 'flickity';
const log = debug('tabs-cards');

class Tabs {
	constructor(node) {
		this.node = node;
		this.active = -1;

		this.navs = Array.from(this.node.querySelectorAll('.tabs-cards__nav-link'));
		this.tabs = Array.from(this.node.querySelectorAll('.tabs-cards__tabs'));

		this.navs.forEach((nav, index) => {
			nav.addEventListener('click', (e) => {
				e.preventDefault();
				this.activate(index);
			});
		});

		this.flickityOpts = {
			adaptiveHeight: false,
			autoPlay: false,
			cellAlign: 'left',
			imagesLoaded: true,
			prevNextButtons: false,
			watchCSS: true,
			wrapAround: false
		}

		this.flickiti = this.tabs.map((tab) => new Flickity(tab, this.flickityOpts));

		this.activate(0);
		log(this);
	}

	activate(index) {
		if (this.active > -1) {
			this.navs[this.active].classList.remove('tabs-cards__nav-link--active');
			this.tabs[this.active].classList.remove('tabs-cards__tabs--active');
		}

		this.active = index;

		this.navs[this.active].classList.add('tabs-cards__nav-link--active');
		this.tabs[this.active].classList.add('tabs-cards__tabs--active');
		if (this.flickiti[this.active] instanceof Flickity) {
			this.flickiti[this.active].resize();
		}
	}
}

export default Tabs;
